<template>
  <v-container>
    <v-layout col wrap justify-center>
      <v-flex xs12 md10 pa-0>
        <v-card>
          <div class="hide-overflow" style="position: relative;">
            <v-toolbar color="lime" absolute>
              <v-toolbar-title style="color:#0b2b49">Contact List</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-flex xs4 sm4 md4>
                <v-text-field label="search" v-model="search"></v-text-field>
              </v-flex>
            </v-toolbar>
            <div id="scrolling-techniques" class="scroll-y" style="height:80%; margin-top: 50px;">
              <v-container>
                <v-list two-line>
                  <template v-for="(contact, index) in filterContacts">
                    <v-list-tile :key="contact.id" avatar ripple @click="onLoadContact(contact.id)">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ contact.name }}</v-list-tile-title>
                        <v-list-tile-action-text>{{ contact.position }}</v-list-tile-action-text>
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-icon :class="[contact.iconClass]" left>{{ contact.icon }}</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider v-if="index + 1 < filterContacts.length" :key="index"></v-divider>
                  </template>
                </v-list>
              </v-container>
            </div>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-btn
      v-if="isAdmin"
      bottom
      right
      fixed
      dark
      fab
      color="green"
      style="margin-bottom:50px;"
      router
      to="/ContactList/new"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-btn
      bottom
      right
      fixed
      fab
      color="lime"
      style="margin-right:70px; margin-bottom:50px;"
      @click="scrollToTop"
    >
      <v-icon>arrow_upward</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      contacts: [],
      search: ""
    };
  },
  computed: {
    filterContacts: function() {
      
      return this.$store.getters.loadedContacts.filter(contact => {
        // If i return True then the contact Stays in the array, if i return False then this contact is Removed from the array
        const filtered =
          contact.name.toLowerCase().match(this.search.toLowerCase()) ||
          contact.area.toLowerCase().match(this.search.toLowerCase()) ||
          contact.sector.toLowerCase().match(this.search.toLowerCase()) ||
          contact.position.toLowerCase().match(this.search.toLowerCase()) ||
          contact.work_No.toLowerCase().match(this.search.toLowerCase()) ||
          contact.mobile.toLowerCase().match(this.search.toLowerCase()) ||
          contact.mobile_short.toLowerCase().match(this.search.toLowerCase());

        return filtered;
      });
    },
    loading() {
      return this.$store.getters.loading;
    },
    isAdmin() {
      if (this.$store.getters.user.id === "l0GxQQzn9iTs5phuG7FvifWvorR2") {
        return true;
      } else {
        return false;
      }
    }
  },
    // load the contacts with the Component. This is due to created()
  created() {
    var contacts = this.$store.dispatch("loadContacts");
  },
  methods: {
    onLoadContact(id) {
      this.$router.push("/Contact/" + id);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
};
</script>